import React, {
    useMemo
} from "react";

import {
    Autocomplete,
    TextField,
    Box,
    Chip,
    Typography,
    CircularProgress
} from "@mui/material";

import SchoolIcon
    from "@mui/icons-material/School";

import Swal
    from "sweetalert2";

import {
    useAcademicYear
} from "../../AcademicYearContext";

const SelectAcademyYear = () => {

    const {

        academicYears,

        selectedYear,

        activateYear,

        loading,

        initialized

    } = useAcademicYear();

    /*
     * Always use the fresh object from
     * the API response.
     */
    const currentSelectedYear =
        useMemo(
            () => {

                if (
                    !selectedYear
                ) {

                    return null;

                }

                return (
                    academicYears.find(
                        year =>
                            year.id ===
                            selectedYear.id
                    ) ||
                    selectedYear
                );

            },
            [
                academicYears,
                selectedYear
            ]
        );

    const handleYearChange =
        async (
            event,
            newValue
        ) => {

            if (
                !newValue ||
                newValue.id ===
                currentSelectedYear?.id
            ) {

                return;

            }

            try {

                await activateYear(
                    newValue.id
                );

                Swal.fire({

                    icon:
                        "success",

                    title:
                        "Active Year Changed",

                    text:
                        `${newValue.name} is now the active academic year.`,

                    timer:
                        1500,

                    showConfirmButton:
                        false

                });

            } catch (
                error
            ) {

                console.error(
                    "Academic year change error:",
                    error
                );

                Swal.fire({

                    icon:
                        "error",

                    title:
                        "Error",

                    text:
                        "Unable to change academic year."

                });

            }

        };

    /*
     * Prevent the selector from rendering
     * an empty/incorrect state while the
     * provider is initializing.
     */
    if (
        !initialized ||
        loading
    ) {

        return (

            <Box
                sx={{
                    width: {
                        xs: "160px",
                        sm: "220px"
                    },

                    height:
                        "42px",

                    display:
                        "flex",

                    alignItems:
                        "center",

                    justifyContent:
                        "center"
                }}
            >

                <CircularProgress
                    size={22}
                />

            </Box>

        );

    }

    return (

        <Box
            sx={{
                width: {
                    xs: "160px",
                    sm: "220px"
                },

                display:
                    "flex",

                alignItems:
                    "center"
            }}
        >

            <Autocomplete

                fullWidth

                value={
                    currentSelectedYear
                }

                options={
                    academicYears
                }

                loading={
                    loading
                }

                onChange={
                    handleYearChange
                }

                disableClearable

                getOptionLabel={
                    option =>
                        option?.name ||
                        ""
                }

                isOptionEqualToValue={(
                    option,
                    value
                ) =>
                    option?.id ===
                    value?.id
                }

                ListboxProps={{
                    sx: {

                        maxHeight:
                            academicYears.length >
                            5
                                ? 250
                                : "auto"

                    }

                }}

                renderOption={(
                    props,
                    option
                ) => (

                    <Box
                        component="li"
                        {...props}
                        sx={{
                            display:
                                "flex",

                            justifyContent:
                                "space-between",

                            alignItems:
                                "center",

                            width:
                                "100%"
                        }}
                    >

                        <Typography
                            fontWeight={
                                option.is_active
                                    ? 700
                                    : 400
                            }
                        >

                            {
                                option.name
                            }

                        </Typography>

                        {
                            option.is_active && (

                                <Chip
                                    label="Active"
                                    size="small"
                                    color="success"
                                />

                            )
                        }

                    </Box>

                )}

                renderInput={(
                    params
                ) => (

                    <TextField

                        {...params}

                        size="small"

                        placeholder={
                            "Select Year"
                        }

                        InputProps={{

                            ...params.InputProps,

                            startAdornment: (

                                <>

                                    <SchoolIcon
                                        sx={{
                                            mr:
                                                0.5,

                                            color:
                                                "primary.main"
                                        }}
                                    />

                                    {
                                        params
                                            .InputProps
                                            .startAdornment
                                    }

                                </>

                            ),

                            endAdornment: (

                                <>

                                    {
                                        currentSelectedYear && (

                                            <Chip
                                                label="Active"
                                                color="success"
                                                size="small"
                                                sx={{
                                                    mr:
                                                        1,

                                                    fontSize:
                                                        "11px"
                                                }}
                                            />

                                        )
                                    }

                                    {
                                        params
                                            .InputProps
                                            .endAdornment
                                    }

                                </>

                            )

                        }}

                        sx={{

                            "& .MuiOutlinedInput-root":
                                {

                                    borderRadius:
                                        "12px",

                                    background:
                                        "#fff",

                                    height:
                                        "42px"

                                }

                        }}

                    />

                )}

                noOptionsText={
                    "No Academic Years Found"
                }

            />

        </Box>

    );

};

export default SelectAcademyYear;



// import React from "react";

// import {
//   Autocomplete,
//   TextField,
//   Box,
//   Chip,
//   Typography,
// } from "@mui/material";

// import SchoolIcon from "@mui/icons-material/School";
// import Swal from "sweetalert2";

// import { useAcademicYear } from "../../AcademicYearContext";



// const SelectAcademyYear = () => {

//   const {
//     academicYears,
//     selectedYear,
//     setSelectedYear,
//     activateYear,
//     loading,
//   } = useAcademicYear();



//   // Change Academic Year
//   // const handleYearChange = async (
//   //   event,
//   //   newValue
//   // ) => {

//   //   if (!newValue) return;


//   //   try {


//   //     // Update backend active year
//   //     await activateYear(
//   //       newValue.id
//   //     );



//   //     // Update frontend selected year
//   //     setSelectedYear(
//   //       newValue
//   //     );



//   //     // Persist selection
//   //     localStorage.setItem(
//   //       "selectedYear",
//   //       JSON.stringify(newValue)
//   //     );



//   //     window.dispatchEvent(
//   //       new Event("academic-year-updated")
//   //     );



//   //     Swal.fire({

//   //       icon: "success",

//   //       title: "Active Year Changed",

//   //       text:
//   //         `${newValue.name} is now the active academic year.`,

//   //       timer: 1500,

//   //       showConfirmButton: false,

//   //     });



//   //   } catch(error) {


//   //     console.log(
//   //       "Academic year change error:",
//   //       error
//   //     );


//   //     Swal.fire({

//   //       icon: "error",

//   //       title: "Error",

//   //       text:
//   //         "Unable to change academic year.",

//   //     });


//   //   }

//   // };

// const handleYearChange = async (
//     event,
//     newValue
// ) => {

//     if (!newValue) return;

//     try {

//         await activateYear(
//             newValue.id
//         );

//         Swal.fire({
//             icon: "success",
//             title: "Active Year Changed",
//             text:
//                 `${newValue.name} is now the active academic year.`,
//             timer: 1500,
//             showConfirmButton: false
//         });

//     } catch (error) {

//         console.error(
//             "Academic year change error:",
//             error
//         );

//         Swal.fire({
//             icon: "error",
//             title: "Error",
//             text:
//                 "Unable to change academic year."
//         });

//     }

// };



//   return (

//     <Box

//       sx={{

//         width: {

//           xs: "160px",

//           sm: "220px",

//         },


//         display: "flex",

//         alignItems: "center",

//       }}

//     >



//       <Autocomplete


//         value={
//           selectedYear || null
//         }


//         onChange={
//           handleYearChange
//         }


//         options={
//           academicYears || []
//         }


//         loading={
//           loading
//         }



//         getOptionLabel={(option) =>

//           option.name || ""

//         }



//         isOptionEqualToValue={

//           (option, value) =>

//             option.id === value.id

//         }



//         disableClearable



//         ListboxProps={{

//           sx: {

//             maxHeight:

//               academicYears.length > 5

//                 ? 250

//                 : "auto",

//           },

//         }}



//         renderOption={

//           (props, option) => (

//             <Box

//               component="li"

//               {...props}


//               sx={{

//                 display: "flex",

//                 justifyContent:
//                   "space-between",

//                 width: "100%",

//               }}

//             >


//               <Typography

//                 fontWeight={

//                   option.is_active

//                     ? 700

//                     : 400

//                 }

//               >

//                 {option.name}

//               </Typography>



//               {

//                 option.is_active &&

//                 <Chip

//                   label="Active"

//                   size="small"

//                   color="success"

//                 />

//               }


//             </Box>

//           )

//         }



//         renderInput={

//           (params) => (

//             <TextField

//               {...params}


//               size="small"


//               placeholder="Select Year"



//               InputProps={{

//                 ...params.InputProps,


//                 startAdornment: (

//                   <>

//                     <SchoolIcon

//                       sx={{

//                         mr: 0.5,

//                         color:
//                           "primary.main",

//                       }}

//                     />


//                     {
//                       params.InputProps.startAdornment
//                     }

//                   </>

//                 ),



//                 endAdornment: (

//                   <>


//                     {

//                       selectedYear &&

//                       <Chip

//                         label="Active"

//                         color="success"

//                         size="small"

//                         sx={{

//                           mr: 1,

//                           fontSize:
//                             "11px",

//                         }}

//                       />

//                     }


//                     {
//                       params.InputProps.endAdornment
//                     }


//                   </>

//                 ),

//               }}



//               sx={{

//                 "& .MuiOutlinedInput-root": {

//                   borderRadius:
//                     "12px",

//                   background:
//                     "#fff",

//                   height:
//                     "42px",

//                 },

//               }}

//             />

//           )

//         }

//       />


//     </Box>

//   );

// };



// export default SelectAcademyYear;